import 'angular-route';
import angular from 'angular';
import router from './module.users.routes';
import commonServicesModule from '../../services';

export const usersModule = {
	name: 'users',
	controllers: {
		default: 'usersCtrl',
	},
	routes: {
		list: '/users',
	},
};

export default angular
	.module(usersModule.name, ['ngRoute', commonServicesModule])
	.config(router)
	.controller(usersModule.controllers.default, require('./usersCtrl')).name;
